import React from 'react';
import { LandingVInt } from './pages/LandingVInt';
// Reads variant set by index.tsx before render — no re-computation here.
// 100% traffic now goes to VINT (international digital-only).
export function App() {
  return <LandingVInt data-id="element-0" />;
}